import immutable from 'seamless-immutable';
import { createReducer, completeReducer, completeState, onReadValue } from 'redux-recompose';

import { actions } from './actions';

const defaultState = completeState({
  adminUser: null,
  kdsAccess: null,
  userPolicies: null,
  userActions: null
});

const reducerDescription = {
  primaryActions: [actions.GET_CURRENT_USER],
  override: {
    [actions.SET_KDS_ACCESS]: onReadValue(),
    [actions.SET_USER_POLICIES]: onReadValue(),
    [actions.SET_USER_ACTIONS]: onReadValue()
  }
};

const reducer = createReducer(immutable(defaultState), completeReducer(reducerDescription));
export default reducer;
